/**
 * TanStack Query client configuration.
 * Forked from XanBZS: apps/web/src/lib/react-query/query-client.ts
 */

/// <reference types="vite/client" />
import { type DefaultOptions, QueryClient } from "@tanstack/react-query";
import { isNetworkError } from "@/lib/errors";

const defaultOptions: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: import.meta.env.PROD,
    retry: (failureCount, error) => failureCount < 3 && isNetworkError(error),
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30_000),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnMount: true,
    refetchOnReconnect: "always",
    refetchInterval: false,
    refetchIntervalInBackground: false,
  },
  mutations: {
    retry: 0,
  },
};

let queryClientInstance: QueryClient | undefined;

export function getQueryClient(): QueryClient {
  if (!queryClientInstance) {
    queryClientInstance = new QueryClient({ defaultOptions });
  }
  return queryClientInstance;
}

export function resetQueryClient(): void {
  if (queryClientInstance) {
    queryClientInstance.clear();
    queryClientInstance = undefined;
  }
}
